import { createContext, useContext } from 'react';

/** What the Bureau's shell lends to the pages inside it. */
export interface BureauShellValue {
  /** A phone: the sidebar and the page take the whole screen in turn. */
  isMobile: boolean;
  /** Opens the sidebar over the page (phone), from a page without its own way back. */
  openNav: () => void;
  /**
   * A path of the Bureau or the Équipe with what the sidebar keeps (its lists' views, themes, lane):
   * a link inside a page must not reset the sidebar (`KeptLink`).
   */
  withKept: (path: string) => string;
}

export const BureauShellContext = createContext<BureauShellValue>({
  isMobile: false,
  openNav: () => undefined,
  withKept: (path) => path,
});

export const useBureauShell = (): BureauShellValue => useContext(BureauShellContext);
